import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SparklesIcon, XIcon } from 'lucide-react';
export function AnnouncementBanner() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-23">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="sticky top-0 z-50 bg-gradient-to-r from-orange-600 to-red-600 text-white py-3 px-6 shadow-lg" data-id="element-24">
          <div className="max-w-7xl mx-auto flex items-center justify-between gap-4" data-id="element-25">
            <div className="flex items-center gap-3 flex-grow justify-center" data-id="element-26">
              <SparklesIcon className="w-5 h-5 flex-shrink-0 animate-pulse" data-id="element-27" />
              <p className="text-sm md:text-base font-bold text-center" data-id="element-28">
                🎉 End of Year Special:{' '}
                <span className="underline" data-id="element-29">$497 Setup Fee WAIVED</span> — Only
                5 Spots Left!
              </p>
              <SparklesIcon className="w-5 h-5 flex-shrink-0 animate-pulse" data-id="element-30" />
            </div>
            <button onClick={() => setIsVisible(false)} className="flex-shrink-0 text-white hover:text-gray-200 transition-colors p-1" aria-label="Dismiss banner" data-id="element-31">
              <XIcon className="w-5 h-5" data-id="element-32" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}